import React, { Component } from 'react';

import { Marker } from 'google-maps-react';

import firstPoleIcon from '../../../images/a_point.svg';
import lastPoleIcon from '../../../images/b_point.svg';


class SelectedPortals extends Component {

    shouldComponentUpdate(nextProps) {
        
        if(//!this.comparePortalLists(this.props.portalsList, nextProps.portalsList)|| 
               this.props.showPortalsOnlyForSelectedOHL !== nextProps.showPortalsOnlyForSelectedOHL 
            || this.props.zoomLevel !== nextProps.zoomLevel 
            || this.props.selectedOHLs !== nextProps.selectedOHLs
            || this.props.showLargeIcons !==  nextProps.showLargeIcons){
            return true;
        }
        else{
            return false; 
        }
    }

    comparePortalLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if(list1.length !== list2.length){
            return false;
        }
        return true;
    }

    componentDidUpdate = () => {
        let resultList = [];

        if(this.props.showPortalsOnlyForSelectedOHL && this.props.selectedOHLs.length === 1 && this.props.zoomLevel > 0){
            const ohl = this.props.selectedOHLs[0];
            const poles = ohl.poles;

            if(poles){
                const portalA = poles.filter(stub => stub.portal && stub.index === 1).map((stub) =>
                    <Marker
                        options={{ icon: firstPoleIcon }}
                        key='0000'
                        onClick={this.props.onPortalClick}
                        position={{ lat: stub.lat, lng: stub.lng }}
                        title={'OHL: ' + ohl.name + ' Name: ' + stub.name}
                        ohlName={ohl.name}
                        poleName={stub.name}
                        poleItemIndex={stub.index}
                    />
                );

                const portalB = poles.filter(stub => stub.portal && stub.index !== 1).map((stub) =>
                    <Marker
                        options={{ icon: lastPoleIcon }}
                        key='9999'
                        onClick={this.props.onPortalClick}
                        position={{ lat: stub.lat, lng: stub.lng }}
                        title={'OHL: ' + ohl.name + ' Name: ' + stub.name}
                        ohlName={ohl.name}
                        poleName={stub.name}
                        poleItemIndex={stub.index}
                    />
                );
                resultList.push(portalA);
                resultList.push(portalB);
            }
        }
        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);

    }

    render() {
        return null;
    }
}


export default SelectedPortals;